import { render, staticRenderFns } from "./MixAggregateList.vue?vue&type=template&id=5d8a60b0&scoped=true"
import script from "./MixAggregateList.vue?vue&type=script&lang=js"
export * from "./MixAggregateList.vue?vue&type=script&lang=js"
import style0 from "./MixAggregateList.vue?vue&type=style&index=0&id=5d8a60b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a60b0",
  null
  
)

export default component.exports